import { NamePath } from 'antd/es/form/interface';
import FormSelect from 'components/form/FormSelect';

interface LocationsFilterProps {
  name?: NamePath;
  nameInRoot?: NamePath;
}

const VALIDATE_RULES = [{ required: true, message: 'Missing value' }];
const REFERENCE = {
  labelProp: 'name',
  model: 'locations',
  searchKey: 'name',
};

export default function LocationsFilter({
  name,
  nameInRoot,
}: LocationsFilterProps) {
  return (
    <FormSelect
      nameFormItem={name}
      name={nameInRoot}
      rules={VALIDATE_RULES}
      reference={REFERENCE}
      placeholder="No selection"
    />
  );
}
